export default "__VITE_ASSET__84703415__"